module.exports = __webpack_public_path__ + "success.de4ee7ad58f75b356c97.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/images/icon/success.svg
// module id = ../../../../../theme/images/icon/success.svg
// module chunks = styles